import { useQuery } from 'react-query';

import { categoriesToOptionsConverter } from '../../../utils/categoriesToOptionsConverter';

import { getDayCategory } from 'RestAPIs/dutyHourTypes';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';

export const useGetDayCategoryOptions = () =>
  useQuery<Option[]>({
    queryKey: ['day_category', 'options'],
    queryFn: async () =>
      await getDayCategory().then(categoriesToOptionsConverter({})),
    staleTime: Infinity
  });
